import React from 'react';
import ReactDOM from 'react-dom';
import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';

import JobsDataGrid from './JobsDataGrid';
import TabFromItem from './TabFromItem';
import styles from './styles.css';
import Warning from '../utils/Warn';



export default class JobsForm extends React.Component{
	constructor(props, context) {
		super(props, context);
	

    	this.state = {
			

			SelectJob:'',

			pastetype: 0,

			// tabactive:1, //tab页的active状态  默认为1
			active: 0, // 0 是默认第一个，不要的话就空''
			tabhandle2: '',
			tabhref2:'#',
			tabhandle3: '',
			tabhref3:'#',
			tabtype: 'Null',
			jsondata:'',

			PasteType:'',
			PasteHeader:'',
			PasteData:'',
			PasteJobName:'',
			Remotearg:'',
			PasteJobDes:'',
			IsPaste:0,

			ChoseJobName:'',
			ResultObj:'',
			Grid1Data:'', //用于存放
			GridDataList:'',
		};
		

	}

	componentDidMount() {
		var command = Command.createService(
		  "gongqi.erp.gotmodel.services.JobService",
		  "jobs",
		  "List"
		);
		var _resultHandler = function(data) {
			window.jobsresult = data.result;
			ReactDOM.render(<JobsForm />,document.getElementById('JobsFormDiv')); 

		};
		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
		  ServiceHelper.addTokenWithCommand(remoteArg);

		$(this.JobsForm_Container).draggable({
		  handle: ".modal-header" // 只能点击头部拖动
		}); //为模态对话框添加拖拽
	}

	componentWillUpdate(){
		if (window.jobsresult.length >0 && this.state.active == 0) {
			if(this.state.SelectJob==""){
				this.handleClick(0,window.jobsresult[0].jobName);
			}
		}
	}

	test(){
		alert("123");
	}

	//关闭
	hideJobsForm=()=>{
		let $reactComponentContainer = $("#JobsFormDiv");
		ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
		//$reactComponentContainer.remove();
  		$("#JobsFormDiv").empty().css("display","none");
	}
	onPaste=(e)=> {
		// alert("触发了粘贴");
		let cpTxt = "复制的数据";
		let clipboardData = window.clipboardData; //for IE
		if (!clipboardData) { // for chrome
		clipboardData = e.clipboardData;
		}
		let result = clipboardData.getData("text") + ":" + cpTxt;
	}

	PasteFun =(e)=>{

		let cbd = e.clipboardData;
        let ua = window.navigator.userAgent;

        e.stopPropagation();
        e.preventDefault();

        // 如果是 Safari 直接 return
        if (!cbd || !cbd.items || !cbd.types) return;

        // Mac平台下Chrome49版本以下 复制Finder中的文件的Bug Hack掉
        if (cbd.items.length === 2 && cbd.items[0].kind === 'string' && cbd.items[1].kind === 'file' && cbd.types.length === 2 && cbd.types[0] === 'text/plain' && cbd.types[1] === 'Files' &&
          ua.match(/Macintosh/i) && ~~(ua.match(/Chrome\/(\d{2})/i)[1]) < 49) return;

        // for (let i = 0, len = cbd.items.length; i < len; i++) {
        //   let item = cbd.items[i];
        //   // 文件类型上传
        //   if (item.kind === 'file') {
        //     let blob = item.getAsFile();
        //     if (blob.size === 0) return;
        //     let fileName = cbd.getData('text/plain');
        //     // 上传文件
        //     return uploader(blob, { name: fileName });
        //   }
        // }
		let text = cbd.getData('text/plain');
		this.pastedata = text;

		const { pastetype } = this.state;
		this.setState({
			IsPaste:1
		})
		switch (pastetype) {
			case 1:
				this.DataGirdViewCellPaste();
				break;
			case 2:
				this.PasteString();
				break;
			default:
				this.paste1Handler();
				break;
		}		
	}
	PasteString=()=>{
		var text = this.pastedata;
		$("#txtModeInput").val(text);
	}

	//datagrid粘贴
	DataGirdViewCellPaste=(e)=> {
		$("#inputDataGridText").css("display","none");
		$("#inputDataGrid").css("display","block");

		// var data = $("#inputDataGridText textarea").val();
		var data = this.pastedata;
		// alert(data);
		
		var text = data;
		var colNum = 0;

		const {PasteJobName,PasteJobDes} = this.state;

		const remotearg = this.state;


		if (remotearg == null)
		  return null;
		
		if (text == null || text == "") {
		  FadeAlert.show("未在剪贴板中找到文本数据");
		  return null;
		}
		try {
		  var rows = text.split("\n");
		  var colnum = -1;
		  var ac = [];
		  var obj;
		  var i = 0;
		  var k = 0;
		  var headers=[];
		  var gc;
		  for(var n=0;n<rows.length;n++){
		  //for each(var row: String in rows) {
			var row = rows[n];
		    if (row == "")
		      continue;
		    var columns = row.split(/[\t]/g);
		    if (colnum == -1)
		      colnum = columns.length;
		    k = 0;
			obj = {};
			for(var m = 0;m<columns.length;m++){
		    //for each(var coldata: String in columns) {
			  var coldata = columns[m];
		      if (i == 0) {
		        gc = {};
		        if (remotearg.isDataWithHeader == true) {
		          gc.name = coldata;
				  gc.key = coldata;
				  gc.resizable = true;
		        } else {
		          obj[k] = coldata;
		          gc.key = k;
		          gc.resizable = true;
		        }
		        //gc.dataField = String(k);
		        headers.push(gc);
		      } else {
		        //第一行与第二行所标识的列数不一样 以第一行为准 后面的将忽略
		        if (k > headers.length - 1) {
		          gc = {};
		          gc.name = " ";
				  gc.key = k;
		          gc.resizable = true;
		          headers.push(gc);
		          //break;
		        }
		        var key = headers[k].key;
		        obj[key] = coldata;
		        //obj[String(k)] = coldata;
		      }
		      k++;
		      if (colNum != 0 && k == colNum)
		        break;
		    }

		    if (remotearg.isDataWithHeader == true) {
		      if (i != 0)
		        ac.push(obj);
		    } else {
		      ac.push(obj);
		    }
		    i++;
		  }
		  //g.columns = headers;
		  //g.dataProvider = ac;
		  //if(gdata)gdata = ac;else g.dataProvider = ac;
		 

		} catch (e) {
		  alert("无法解析复制的文本");
		}


			// this.jobsDataGrid.setState({rows:ac});
			// const{PasteHeader,PasteData,PasteType} = this.state;
			console.log(headers);
			
			
			this.jobsDataGrid.setState({
				columns: headers,
				rows:ac
			});
			setTimeout(this.jobsDataGrid.forceUpdate.bind(this.jobsDataGrid), 100);

			this.setState({
				GridDataList:ac
			})
			// return;

		// 	var result = {columns:headers,datas:ac};
		// 	return result;
		// 	var rowdata = result.datas;
		// }
		
	}

	//KeyValuezhantie
	paste1Handler=()=>{

		const {Remotearg,PasteHeader} = this.state;
	//   var text = $("#inputDataGridText textarea").val(); //剪切板内容
	var text = this.pastedata;
	  if (text == null || text == "") {
	    alert("未在剪贴板中找到文本数据");
	    return;
	  }
		var remotearg =Remotearg;
		var grid1Data= PasteHeader;
		// var task.arg = remotearg;
	  if (!remotearg)
	    return;
	  if (remotearg.fields && remotearg.fields.length > 0) {
	      var rows = text.split("\n");
	      for (var i = 0; i < grid1Data.length; i++) {
	        var item = grid1Data[i];
	        if (i >= rows.length)
	          break;
	        var row= rows[i];
	        if (row == "")
	          continue;
	        var columns = row.split(/[\t]+/g);
	        var value = columns[columns.length - 1];
	        item.value = value;
	      }
	    //   grid1Data.refresh();

	  } else {
	   
	      var newGrid1Data= [];
	      var rows = text.split("\n");
	      for (var i = 0; i < rows.length; i++) {
	        var row = rows[i];
	        if (row == "")
	          continue;
	        var columns = row.split(/[\t]+/g);
	        if (columns.length == 0)
	          break;
	        if (columns.length == 1)
	          columns.unshift(i);
	        var item = {};
	        for (var k = 0; k < 2; k++) {
	          var key = (k == 0 ? "key" : "value");
	          item[key] = columns[k]
	        }
	        newGrid1Data.push(item);
	      }
	      grid1Data = newGrid1Data;

		}
		
		const{PasteType} = this.state;
		var headerss = [{
			// id: 'grid1Column0',
			key: 'key',
			name: '属性名称'
		}, {
			// id: 'grid1Column1',
			key: 'value',
			name: '属性值'
		}];

		this.jobsDataGrid.setState({
			columns: headerss,
			rows: grid1Data
		});
		setTimeout(this.jobsDataGrid.forceUpdate.bind(this.jobsDataGrid), 100);
		
		this.setState({
			Grid1Data: grid1Data
		})


		$("#inputDataGridText").css("display", "none");
		$("#DataGridpaste").css("display", "block");
		$("#inputDataGrid").css("display", "block");

	}

	doRefreshSelectedJob(jobName) 
	{	
		this.clear();
		var command = Command.createService("gongqi.erp.gotmodel.services.JobService", "jobDeclaration", "Map");
		command.appendArg(jobName);
		const self = this;
		var _resultHandler = function (data) 
		{
			var resultobj = data.result;
			var remotearg = resultobj.paramClipboard;
			self.setState({
				Remotearg:remotearg,
				ResultObj:resultobj
			});
			
			if(resultobj.paramType == null)
			{
				//右侧描述
				var type = "Null";
				self.setState({
				  tabtype: type,
				  jsondata: resultobj
				})
				// $("#DataGridpaste").css("display", 'none');

				//远程调用数据不可点击
				self.setState({
				  tabhandle2: '',
				  tabhref2: '#',
				  tabhandle3:'',
				  tabhref3:'#'
				})
				$("#jobsForm_tab_btn_2").addClass("noclickBtn");
				$("#jobsForm_tab_btn_3").addClass("noclickBtn");

				//调用返回不可点击
				

				// txtArg.editable = false;txtArg.prompt=resultobj.paramDescription==null?"该Job无需调用参数":resultobj.paramDescription;
				// inbox.enabled = false;
				
			}
			else if(resultobj.paramType == "String" && !remotearg)
			{

				//右侧描述
				var type = "String";
				self.setState({
					tabtype: type,
					jsondata: resultobj
				})
				// $("#DataGridpaste").css("display", 'none');

				//远程调用数据不可点击
				self.setState({
					tabhandle2: '',
					tabhref2: '#',
					tabhandle3: '',
					tabhref3: '#'
				})
				$("#jobsForm_tab_btn_2").addClass("noclickBtn");
				$("#jobsForm_tab_btn_3").addClass("noclickBtn");


				//调用返回不可点击

			}
			if (remotearg){

				if(resultobj.paramType == "Map")
				{
					//右侧描述
					var type = "MAP";
					self.setState({
						tabtype: type,
						jsondata: resultobj,
						PasteJobName: jobName,
						PasteJobDes: resultobj.jobDescription,
						PasteType: 'KeyValue',
						pastetype: 0
					})

					$("#DataGridpaste").css("display", 'block');
					// $("#DataGridpaste").attr("onClick", "this.paste1Handler");
					
					//远程调用数据可点击
					self.setState({
						tabhandle2: 'tab',
						tabhref2: '#jobsForm_tab_2',
						tabhandle3: '',
						tabhref3: '#'
					})
					$("#jobsForm_tab_btn_2").removeClass("noclickBtn");
					$("#jobsForm_tab_btn_3").addClass("noclickBtn");

					//调用返回不可点击


					if(remotearg.fields && remotearg.fields.length>0)
					{
						var fixedData=[];
						// for each(var field:ClipboardField in remotearg.fields)
						for (var p = 0; p < remotearg.fields.length; p++)
						{
							var field = remotearg.fields.paramClipboard[p];
							fixedData.push({key:field.label==""?RemotePasteDialog.typetocn[(field.fieldType)]:field.label,value:"",serverfield:field.dataField}); 
						}
						// remotepasteindialog.grid1Data = fixedData;
						self.setState({
							PasteHeader: fixedData
						})
					}
				}
				else if(resultobj.paramType == "List") //List
				{
					//右侧描述
					var type = "LIST";
					self.setState({
						tabtype: type,
						jsondata: resultobj,
						PasteJobName: jobName,
						PasteJobDes: resultobj.jobDescription,
						PasteType: 'List',
						pastetype: 1
					})

					$("#DataGridpaste").css("display",'block');

					// $("#DataGridpaste").attr("onClick", "this.DataGirdViewCellPaste");

					//远程调用数据可点击
					self.setState({
						tabhandle2: 'tab',
						tabhref2: '#jobsForm_tab_2',
						tabhandle3:'',
						tabhref3: '#'
					})
					$("#jobsForm_tab_btn_2").removeClass("noclickBtn");
					$("#jobsForm_tab_btn_3").addClass("noclickBtn");

					//调用返回不可点击
					

					// if(remotepasteindialog.gridColumns)
					// 	remotepasteindialog.gridColumns.removeAll();
					// remotepasteindialog.gridDataProvider = null;
					if(remotearg.fields)
					{
						var headers= [];
						// for each(field in remotearg.fields)
						for (var q = 0; q < remotearg.fields.length; q++)
						{
							var field = fields[q];
							var gc;
							gc.headerText = field.label;
							gc.dataField = field.dataField;
							gc.type = field.fieldType;
							gc.numOfDecimals = field.numOfDecimals;
							headers.push(gc);
						}
						// remotepasteindialog.gridColumns = headers;
					}
				}
				else if (resultobj.returnType == "Clipboard") {
					//右侧描述
					var type = "ReClipboard";
					self.setState({
						tabtype: type,
						jsondata: resultobj,
						PasteType:'',
						pastetype: 2
					})
					$("#DataGridpaste").css("display", 'none');
					
					//远程调用数据可点击
					self.setState({
						tabhandle2: 'tab',
						tabhref2: '#jobsForm_tab_2',
						tabhandle3:'',
						tabhref3: '#'
					})
					$("#jobsForm_tab_btn_2").removeClass("noclickBtn");
					$("#jobsForm_tab_btn_3").addClass("noclickBtn");

					//调用返回不可点击
				}
				else{
					//右侧描述
					var type = "String";
					self.setState({
						tabtype: type,
						jsondata: resultobj,
						PasteType:''
					})
					$("#DataGridpaste").css("display", 'none');

					//远程调用数据可点击
					self.setState({
						tabhandle2: 'tab',
						tabhref2: '#jobsForm_tab_2',
						tabhandle3: '',
						tabhref3: '#'
					})
					$("#jobsForm_tab_btn_2").removeClass("noclickBtn");
					$("#jobsForm_tab_btn_3").addClass("noclickBtn");
				}
			}
			
			

		};
		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};

		ServiceHelper.addTokenWithCommand(remoteArg);

	}


	handleClick(i,jobName){
		const { active } = this.state;
		if (active === i && this.state.jsondata!='') {
			return;
		}else{//点击不同job
			console.log('i', i);
			this.setState({
				SelectJob: jobName,
				active: i,
				ChoseJobName: jobName
			});
			var jobsName = jobName;
			this.doRefreshSelectedJob(jobsName);
		} 		
	}

	getInData(remotearg){
		const {PasteType,Remotearg,Grid1Data} = this.state;
		// var remotearg = Remotearg;
		var grid1Data = Grid1Data;
		if(PasteType == "KeyValue")
		{
			var _arg = {};
			if(remotearg.fields && remotearg.fields.length>0)
			{
				//grid1Data 是ReactDataGrid的rows
				// for each(var item:Object in grid1Data)
				for(var i=0;i<grid1Data.length;i++)
				{
					var item = grid1Data[i];
					_arg[item.serverfield] = item.value;
				}
			}
			else
			{
				var grid1 = this.jobsDataGrid.state;
				//grid1就是keyvalue的reactDataGrid grid1.dataProvider就是它的rows
				// var ac = grid1.dataProvider ;
				var ac = grid1.rows;
				// columns【0】
				var column= new Array();
				column[0] = grid1.columns[0] ;
				column[1] = grid1.columns[1] ;
				//column的key
				var key1 = column[0].key;
				var key2 = column[1].key;
				// for each(item in ac)
				for(var j = 0 ; j<ac.length ; j ++)
				{
					var item = ac[j];
					_arg[item[key1]] = item[key2]; 
				}
			}
			return _arg;
		}
		//DataGrid
		else if(PasteType == "List")
		{
			//datagrid的rows
			const{rows,columns} = this.jobsDataGrid.state;
			var gridDataProvider = rows;
			_arg = gridDataProvider;
			if(!remotearg.fields && remotearg.isDataWithHeader)
			{
				if(_arg == null)
				_arg = {};
				var headerdata = {};
				//columns
				var grid = this.jobsDataGrid.state;
				for(var i = 0;i<grid.columns.length;i++)
				{
					var gc = grid.columns[i] ;
					//headerText就是column里面的name
					headerdata[gc.dataField] = gc.headerText;
				}
				_arg.push(headerdata,0);
			}
			return _arg;
		}
		
		return $("#txtModeInput").val();
	}

	testRemoteClass = ()=>{
		const{ChoseJobName,ResultObj} = this.state;
		var jobName = ChoseJobName;
		var _resultobj = ResultObj;
		var self = this;
		// var selectedItem:Object = listJobs.selectedItem as Object;
		// if(selectedItem == null)
		// 	return;
		
		if (jobName == null)
			return;
		
		var command = Command.createService("gongqi.erp.gotmodel.services.JobService", "execute", "Object");
		
		command.appendArg(jobName);
		
		var argType;
		var argValue;
		
		var _arg;
		
		if(_resultobj.paramType == "String")
		{
			if(_resultobj.paramClipboard)
			{
				// const{IsPaste}= this.state;
				// if(IsPaste == 0){
				// 	alert("请先点击粘贴，然后远程调用");
				// 	return false;
				// }
				_arg = this.getInData(_resultobj.paramClipboard);
			}
			else
			{
				_arg = $("#jobsinput10001").val();
			}
			
			argType = "String";
			argValue = _arg;
		}
		else if(_resultobj.paramType != null) 
		{
			if(_resultobj.paramClipboard){
				const{IsPaste}= this.state;
				if(IsPaste == 0){
					alert("请先点击粘贴，然后远程调用");
					return false;
				}
				_arg = this.getInData(_resultobj.paramClipboard);
			}
			else
				_arg = $("#jobsinput10001").text;
			
			argType = _resultobj.paramType;
			argValue = _arg;
		}
		else
		{
			argType = null;
			argValue = null;
		}

		
		
		command.appendArg(argType, "String");
		command.appendArg(argValue, "Object");

		const self2 = this;

		var rpc_result_btnSubmit = function (data) {
			console.log(data);
			const{Remotearg} = self2.state;
			var remotearg = Remotearg;
			var event= data;
			//var obj:gongqi.erp.forms.sys.remote.Clipboard = event.result as gongqi.erp.forms.sys.remote.Clipboard;
			if(event.result == null)
			{
				alert("远程调用成功");
				
				//   Warning.show({text:"1"});
				// outbox.enabled = false;tabnav.selectedChild = normalbox;//远程调用返回不显示 
			}
			else if(remotearg || event.result.mode=="Out")
			{
				//远程调用数据返回
				self.setState({
				  tabhandle3: 'tab',
				  tabhref3: '#jobsForm_tab_3',
				//   tabactive:3
				});
				$("#jobsForm_tab_btn_3").removeClass("noclickBtn");

				$("#jobsForm_tab_1").removeClass("active");
				$("#tabli_1").removeClass("active");
				$("#jobsForm_tab_2").removeClass("active");
				$("#tabli_2").removeClass("active");
				
				$("#jobsForm_tab_3").addClass("active");
				$("#tabli_3").addClass("active");
					// outbox.enabled = true;tabnav.selectedChild = outbox;

				var remotearg = event.result;
			
				
				if(remotearg.type == "Text")
				{
					// self.setState({
					// 	tabactive:3
					// })
					// remotepasteoutdialog.mode0Text = remotearg.data as String;
					$("#txtModeOutput").val(remotearg.data);
				}
				else if(remotearg.type == "KeyValue")
				{
					$("#outputTextarea").css("display","none");
					$("#outputDataGrid").css("display","block");
					if(remotearg.fields && remotearg.fields.length>1)
					{
						var datas = new Array();
						for(var key in remotearg.data)
						// for (var m= 0; m < remotearg.data.count; m++)
						{
							// var key = remotearg.data[m];
							var data1 = {};
							var keyLabel = "";
							// for each(var field:ClipboardField in remotearg.fields)
							for (var i = 0; i < remotearg.fields.length ; i ++)
							{
								var field = remotearg.fields[i];
								if(field.dataField == key)
									keyLabel = ((field.label==""||field.label==null)?key:field.label);
							}
							data1["key"] = keyLabel;
							data1["value"] = remotearg.data[key];
							datas.push(data1);
						}
						if(datas == null){
							datas= [];
						}
						console.log(datas);
						var headerss = [{
							// id: 'grid1Column0',
							key: 'key',
							name: '属性名称'
						}, {
							// id: 'grid1Column1',
							key: 'value',
							name: '属性值'
						}];
						self2.jobsDataGridOut.setState({
							columns: headerss,
							rows: datas
							// rows: ac
						});
						setTimeout(self2.jobsDataGridOut.forceUpdate.bind(self2.jobsDataGridOut), 100);
					}
					else
					{
						var datas = {};
						for(var key in remotearg.data)
						// for(var j = 0 ; j < remotearg.data ;j++)
						{
							// var key = remotearg.data[j];
							var data1 = {};
							data1["key"] = key;
							data1["value"] = remotearg.data[key];
							datas.push(data1);
						}
						if (datas == null) {
						  datas = [];
						}
						console.log(datas);
						var headerss = [{
							// id: 'grid1Column0',
							key: 'key',
							name: '属性名称'
						}, {
							// id: 'grid1Column1',
							key: 'value',
							name: '属性值'
						}];
						self2.jobsDataGridOut.setState({
							columns: headerss,
							rows: datas
						});
						setTimeout(self2.jobsDataGridOut.forceUpdate.bind(self2.jobsDataGridOut), 100);
						// remotepasteoutdialog.grid1Data = datas;
					}
				}
				else if(remotearg.type == "DataGrid")
				{
					$("#outputTextarea").css("display", "none");
					$("#outputDataGrid").css("display", "block");
					if(remotearg.fields)
					{
						var headers = [];
						const remotobj = remotearg.fields;
						remotobj.map((val) => {
							let gc = {};
							// gc.headerText = val.label;
							// gc.dataField = val.dataField;
							gc.name = val.label;
							gc.key = val.dataField;
							gc.type = val.fieldType;
							gc.numOfDecimals = val.numOfDecimals;
							gc.width = 100;
							headers.push(gc);
						});
						// forEach(field in remotearg.fields)
						// for(var k = 0 ; k < remotearg.fields.length ; k++)
						// {
						// 	var field = remotearg.fields[k];
						// 	var gc = [];
						// 	gc.headerText = field.label;
						// 	gc.dataField = field.dataField;
						// 	gc.type = field.fieldType;
						// 	gc.numOfDecimals = field.numOfDecimals;
						// 	headers.push(gc);
						// }
						const { GridDataList} = self2.state;
						// console.log(GridDataList);
						console.log(headers);
						self2.jobsDataGridOut.setState({
							columns: headers,
							rows: remotearg.data
						});
						setTimeout(self2.jobsDataGridOut.forceUpdate.bind(self2.jobsDataGridOut), 100);
						// remotepasteoutdialog.gridColumns = headers;
						// remotepasteoutdialog.gridDataProvider = remotearg.data as ArrayCollection;
					}
					else
					{
						if(remotearg.data && remotearg.data.length>0)
						{
							headers = new Array();
							var first = remotearg.data[0];
							for(var key in first)
							// for(var i = 0 ; i < first.length ; i ++)
							{
								// var key = first[i];
								var gc = [];
								gc.headerText = key;
								gc.dataField = key;
								headers.push(gc);
							}
							const{GridDataList} = self2.state;
							self2.jobsDataGridOut.setState({
								columns: headers,
								rows: remotearg.data
							});
							setTimeout(self2.jobsDataGridOut.forceUpdate.bind(self2.jobsDataGridOut), 100);
							// remotepasteoutdialog.gridColumns = headers;
							// remotepasteoutdialog.gridDataProvider = remotearg.data as ArrayCollection;
						}
						else
						{
							// AlertInfo.Instance.show("提示","服务端未能传回数据",0x4,Assert.ICON_INFO);
							alert("提示：服务端未能传回数据");
						}
					}
				} 
				else // if(event.result is String)
				{
				  var IsDate = false;
				  var txtReturn;
				  if (IsDate) {
				    // txtReturn= StringHelper.dateToStringDateTime(event.result as Date);
				  } else {
				    txtReturn = event.result.toString();
				    $("#jobsinput10000").val(txtReturn);
				  }
				  $("#jobsForm_tab_3").removeClass("active");
				  $("#tabli_3").removeClass("active");
				  $("#jobsForm_tab_2").removeClass("active");
				  $("#tabli_2").removeClass("active");

				  $("#jobsForm_tab_1").addClass("active");
				  $("#tabli_1").addClass("active");
				  // AlertInfo.Instance.show("远程调用结果",txtReturn.text,Alert.OK,Assert.ICON_INFO);
					//   Warning.show({text:txtReturn});
					//   alert("远程调用结果：" + txtReturn);
					var defaults = {
						state:"success",
						backgroundColor:undefined,
						color:"#fff",
						text:"远程调用结果: "+txtReturn,
						cornerRadius:"10",
						interacdestroy:true,
						cancel:{
							isShow:false,
							event:''
						}
					};
					// alert("远程调用结果：" + txtReturn);
					Warning.show(defaults);
				  // outbox.enabled = false;tabnav.selectedChild = normalbox;
				}
			
				
			// 	if(pasteoutdialogadded==false)
			// 	{
			// 		outbox.addChild(remotepasteoutdialog);pasteoutdialogadded = true;
			// 	}
			}
			else// if(event.result is String)
			{
				var IsDate = false;
				var txtReturn;
				if(IsDate)
				{
					// txtReturn= StringHelper.dateToStringDateTime(event.result as Date);
				}
				else
				{
					txtReturn = event.result.toString();
					$("#jobsinput10000").val(txtReturn);
				}
				
				//远程调用数据返回
				self.setState({
				  tabhandle3: '',
				  tabhref3: '#',
				//   tabactive:1
				})
				$("#jobsForm_tab_btn_3").addClass("noclickBtn");

				$("#jobsForm_tab_3").removeClass("active");
				$("#tabli_3").removeClass("active");
				$("#jobsForm_tab_2").removeClass("active");
				$("#tabli_2").removeClass("active");

				$("#jobsForm_tab_1").addClass("active");
				$("#tabli_1").addClass("active");

				// AlertInfo.Instance.show("远程调用结果",txtReturn.text,Alert.OK,Assert.ICON_INFO);
				//   Warning.show({text:txtReturn});
				// $("#jobsinput10000").val(txtReturn);
				var defaults = {
					state:"success",
				 	backgroundColor:undefined,
				 	color:"#fff",
					text:"远程调用结果: "+txtReturn,
				 	cornerRadius:"10",
				 	interacdestroy:true,
				 	cancel:{
				 		isShow:false,
				 		event:''
				 	}
				};
				// alert("远程调用结果：" + txtReturn);
				Warning.show(defaults);
				// outbox.enabled = false;tabnav.selectedChild = normalbox;
			}
		}

		var remoteArg = {command:command,resultFunction:rpc_result_btnSubmit,sync:false};
  		ServiceHelper.addTokenWithCommand(remoteArg);
		
	}
	
	clear = ()=>{
		$("#txtModeOutput").val("");
		$("#txtModeInput").val("");
		$("#inputDataGridText").css("display", "block");
		$("#inputDataGrid").css("display", "none");
		$("#outputTextarea").css("display", "block");
		$("#inputDataGrid").css("display", "none");

		this.jobsDataGridOut.setState({
		  colnums: [],
		  rows: []
		})
		setTimeout(this.jobsDataGridOut.forceUpdate.bind(this.jobsDataGridOut), 100);


		this.jobsDataGrid.setState({
			colnums:[],
			rows:[]
		})
		setTimeout(this.jobsDataGrid.forceUpdate.bind(this.jobsDataGrid), 100);
	}

	btnRefreshCurClickHandler=(e)=>{
		const{SelectJob} = this.state;
		this.doRefreshSelectedJob(SelectJob);
	}

	render(){
		var result1 = window.jobsresult;
		const {
			tabactive,
			active,
			tabhandle2,
			tabhref2,
			tabhandle3,
			tabhref3,
			tabtype,
			jsondata
		} = this.state;
		
		
		return(

			<div ref={node=>this.JobsForm_Container=node} style={{alignSelf:"center",border:"2px solid #e5e5e5",borderRadius:"2px",backgroundColor:'white',width:'900px',height:'532px',display:'flex',flexDirection:'column'}}>
		      <div className="modal-header" style={{position:"relative"}}>
				<div className="modal-close" onClick={this.hideJobsForm.bind(this)}></div>
		        <h5 className="modal-title">远程调用</h5>
		      </div>
              <div style={{display:'flex',flexDirection:'column',flexGrow:100,padding:'5px'}}>
		       	<div style={{display:'flex',flexDirection:'row',flexGrow:100,boxShadow:'0 1px 1px rgba(0, 0, 0, 0.1)',borderRadius:'3px'}}>
                    <div style={{display:'flex',flexDirection:'column',width:'900px'}}>
		       			<div className="nav-tabs-custom" style={{'marginBottom': '0',display:'flex',flexDirection:'column',height:'100%'}}>
          					<ul id="jobsNav" className="nav nav-tabs">
            					<li id="tabli_1" className="active"><a className="gongqi_tabpage" href="#jobsForm_tab_1" data-toggle="tab" aria-expanded="false">远程调用</a></li>
            					<li id="tabli_2" ><a className="gongqi_tabpage noclickBtn" id="jobsForm_tab_btn_2" href={tabhref2} data-toggle={tabhandle2} aria-expanded="false">远程调用数据</a></li>
            					<li id="tabli_3" ><a className="gongqi_tabpage noclickBtn" id="jobsForm_tab_btn_3" href={tabhref3} data-toggle={tabhandle3} aria-expanded="false">远程调用返回</a></li>
          					</ul>
                            <div className="tab-content" style={{'padding':'0px',flexGrow:100,width:'100%',height:'100%'}}>
            					<div className="active tab-pane" id="jobsForm_tab_1" style={{width:'100%',height:'100%',padding:'1px'}}>
            						<div style={{display:'flex',flexDirection:'row',width:'100%',height:'100%'}}>
										<div style={{display:'flex',flexDirection:'column',width:'70%',height:'100%',padding:'1%',border:'1px solid #ccc',height:'390px',overflow:'auto',borderBottom:'none'}}>
											<ul id="jobslist">
												{
													result1.map((item, i) => (
													<li key={i} 
														onClick={this.handleClick.bind(this,i,item.jobName)} 
														style={{lineHeight:'30px',listStyleType:'none'}} 
														className = {
															(active === i ? 'active' : '')
														}
													>
														<span style={{fontWeight:'bold'}}>{item.jobName}</span>
														<span className="li_jobsDes" style={{float:'right'}}>{item.jobDescription}</span>
													</li>
							
												))}
											</ul>
										</div>
										<div style={{display:'flex',flexDirection:'column',width:'30%',height:'100%',padding:'1%'}}>
											
											<TabFromItem type ={tabtype} a={jsondata} > </TabFromItem>
										
												{/* <div style={{paddingTop:'20px'}}>
													<div id="JobsEditor10000" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
														<label for="jobsinput10000" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>返回值：  </label>
														<div style={{position: 'relative'}}>
															<input type="text" spellcheck="false" id="jobsinput10000" disabled className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
														</div>
													</div>
													<div id="JobsEditor10001" className="editorGroup" style={{display: 'flex', flexDirection: 'row', alignItems: 'center',paddingTop:'5px'}}>
														<label for="jobsinput10001" className="fieldGroupLabel" style={{paddingLeft: '5px', width: 'auto', textAlign: 'right', whiteSpace: 'nowrap',marginBottom: '0px'}}>参&#12288;数：</label>
														<div style={{position: 'relative'}}>
															<input type="text" spellcheck="false" id="jobsinput10001" disabled className="form-control" style={{padding: '2px', height: '22px', width: '180px', fontSize: '12px'}}/>
														</div>
													</div>
												</div> */}
                           				 </div>
              						</div>
            					</div>      
            					<div className="tab-pane"  id="jobsForm_tab_2" style={{width:'100%',height:'100%'}}>
            						<div style={{display:'flex',flexDirection:'column',width:'100%',height:'100%',padding:'1%'}}>
	              						<label>粘贴剪切板数据到下面文本框</label>
										<div id="inputDataGridText" style={{width:'100%',height:'100%',display:'block'}}>
											<textarea id="txtModeInput" onPaste={(e)=> {this.PasteFun(e)}} style={{height:'100%',width:'100%'}}></textarea>
										</div>
										<div id="inputDataGrid" style={{width:'100%',height:'100%',display:'none'}}>
											<JobsDataGrid  ref={node=>this.jobsDataGrid=node} />
										</div>
										{/* <button id="DataGridpaste" type="button" className="btn btn-info" style={{height:'25px',marginRight:'5px',marginTop:'5px',width:'56px',display:'block'}} onClick={this.PasteFun}>粘贴</button> */}
              						</div>
            					</div>
								<div className="tab-pane"  id="jobsForm_tab_3" style={{width:'100%',height:'100%'}}>
									<div style={{display:'flex',flexDirection:'column',width:'100%',height:'100%',padding:'1%'}}>
										<label></label>
										<div id="outputTextarea" style={{width:'100%',height:'100%'}}>
											<textarea id="txtModeOutput" style={{height:'100%',width:'100%'}}></textarea>
										</div>
										<div id="outputDataGrid" style={{width:'100%',height:'100%',display:'none'}}>
											<JobsDataGrid ref={node=>this.jobsDataGridOut=node}/>
										</div>
									</div>
            					</div>
          					</div>
        				</div>
		       		</div>
		       	</div>
		       	<div style={{display:'flex',flexDirection:'horizontal',flexGrow:0,padding:'10px 5px'}}>
          			<div style={{flexGrow:100}}></div>
          			<button type="button" onClick={this.RemoteSubmit} className="btn btn-info" style={{width:'80px',height:'28px',marginRight:'5px',marginTop:'5px'}} onClick={this.testRemoteClass} >远程调用</button>
          			<button type="button" className="btn btn-info" style={{width:'96',height:'28px',marginRight:'5px',marginTop:'5px'}}  onClick={this.btnRefreshCurClickHandler}>刷新当前Job</button>
          			<button type="button" className="btn btn-info" style={{width:'96',height:'28px',marginTop:'5px'}} >刷新Job列表</button>
		       	</div>
		      </div>
		    </div>

		)
	}

}


// WEBPACK FOOTER //
// ./src/jobs/JobsForm.js